import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { Outlet } from "react-router-dom";

/** Pathless route element that makes typed URL state available to every nested route. */
export default function SearchParamsRoot() {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  );
}
